import { Beavis } from './Institutional/Beavis';
import { Garfield } from './Institutional/Garfield';

import { Kirby } from './Primary/Kirby';
import { Luigi } from './Primary/Luigi';
import { Mario } from './Primary/Mario';
import { Milhouse } from './Primary/Milhouse';
import { Randy } from './Primary/Randy';

import { Secondary } from './Secondary/Secondary';

import { White } from './Acromathic/White';
import { Black } from './Acromathic/Black';
import { Gray } from './Acromathic/Gray';

const Colors = {
  Beavis,
  Garfield,

  Kirby,
  Luigi,
  Mario,
  Milhouse,
  Randy,

  Secondary,

  White,
  Black,
  Gray,
};

export { Colors };
